/** @format */

import { RewardDeliveryMethodEnum } from '@shared/data-access/enums';

export interface RewardDeliverySettings {
  rewardDeliveryMethod: RewardDeliveryMethodEnum;
}
